import React, { createContext, useContext, useState } from 'react';

// Auth context — Firebase removed (Phase 0 cleanup).
// Full Amplify v6 implementation lands in Phase 2.

const AuthContext = createContext();

const NOT_CONFIGURED = 'Auth provider not yet configured';

export const AuthProvider = ({ children }) => {
  const [user] = useState(null);
  const [loading] = useState(false);
  const [error] = useState(null);

  const signUp = async () => { throw new Error(NOT_CONFIGURED); };
  const signIn = async () => { throw new Error(NOT_CONFIGURED); };
  const signInWithGoogle = async () => { throw new Error(NOT_CONFIGURED); };
  const logout = async () => { throw new Error(NOT_CONFIGURED); };
  const resetPassword = async () => { throw new Error(NOT_CONFIGURED); };

  const value = {
    user,
    loading,
    error,
    signUp,
    signIn,
    signInWithGoogle,
    logout,
    resetPassword,
    isAuthenticated: false,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
